import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=26425d78&scoped=true"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26425d78",
  null
  
)

export default component.exports